"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import { VaccineStatusModel } from '../../types/VaccineStatusModel'
// import { VaccineSymptomModel } from '../../types/VaccineSymptomModel';
// import { AuthProvider } from '../AuthProvider'
const BaseController_1 = __importDefault(require("./BaseController"));
// export interface VaccineStatusResponse {
// 	status?: VaccineStatusModel;
// 	error?: any;
// }
// export interface FetchBlobResponse {
// 	value?: Blob;
// 	error?: any;
// }
// export interface MedicalQueueLengths {
// 	favorite?: boolean;
// 	wait_time: string;
// 	wait_time_text: string;
// 	location_id: number;
// 	name: string;
// 	day_title: string;
// 	open_time: string;
// 	close_time: string;
// 	is_open: boolean;
// 	medical_queue_indicator: boolean;
// }
// export interface FetchMedicalQueueLengthResponse {
// 	items?: MedicalQueueLengths[];
// 	error?: any;
// }
// export interface FetchPassStatusResponse {
// 	status_model?: PassStatusModel;
// 	error?: any;
// }
// export interface FetchStringResponse {
// 	value?: string;
// 	error?: any;
// }
// export interface FetchPersonRelationshipsResponse {
// 	items?: RelationshipInterface[];
// 	error?: any;
// 	unauth?: any;
// }
// export interface RelationshipInterface {
// 	person_relationship_type_id: number,
// 	name: string;
// }
class DataController extends BaseController_1.default {
    // readonly url_vaccine: string;
    // readonly url_medical_queue_time: string;
    // readonly url_barcode: string;
    // readonly url_fetch_results: string;
    // readonly url_tests_result_pdf: string;
    // readonly url_pass_status: string;
    // url_fetch_flu_shots: string;
    // url_fetch_vaccines: string;
    constructor() {
        super();
        // checkStatusCode(status: number): boolean {
        //       return status >= 200 && status < 300
        //   }
        // fetchArray = async (endpoint: string): Promise<FetchArrayResponse> => {
        // 	let response = await this.useFetch('GET', 'fetchArray',`${this.url_array}/${endpoint}`)
        // 	if (response.status === 200) {
        // 		let data = await response.json()
        // 		return { items: data }
        // 	} else {
        // 		return {
        // 			error: true
        // 		}
        // 	}
        // }
        this.fetchArray = (endpoint) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_array}/${endpoint}`, yield this.requestHeaderGet());
            if (response.status >= 200 && response.status < 300) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true
                };
            }
        });
        this.url_array = `${this.apiHost}/${this.apiPathPass}/pass`;
        // 	this.url_vaccine = `${this.apiHost}/${this.apiPathVaccine}/vaccine`;
        // 	this.url_medical_queue_time = `${this.apiHost}/${this.apiPathPass}/pass/medical/queue_times`;
        // 	this.url_barcode = `${this.apiHost}/${this.apiPathPass}/daily_pass`;
        // 	this.url_fetch_results = `${this.apiHost}/${this.apiPathMedical}/tests/results?optional=flu_shots`;
        // 	this.url_fetch_flu_shots = `${this.apiHost}/${this.apiPathMedical}/tests/results?optional=flu_shots,flushot_missing`;
        // 	this.url_fetch_vaccines = `${this.apiHost}/${this.apiPathMedical}/tests/results?optional=vaccine,vaccine_missing,exemption`;
        // 	// this.url_fetch_results = `${this.apiHost}/${this.apiPathMedical}/tests/results?optional=medical,flu_shots,vaccine,exemption,vaccine_missing,flushot_missing`;
        // 	// this.url_fetch_results = `${this.apiHost}/${this.apiPathMedical}/tests/results?optional=exemption`;
        // 	this.url_tests_result_pdf = `${this.apiHost}/${this.apiPathMedical}/tests/result/pdf`;
        // 	this.url_pass_status = `${this.apiHost}/${this.apiPathPass}/pass/access_status`;
    }
}
const dataController = new DataController();
exports.default = dataController;
